import { Button, Result } from 'antd';
import { useEffect, useState } from 'react';
import { history, useModel } from '@umijs/max';
import { getInitPath, PERMISSIONS } from '@/constants';
import { findParentByKey } from '@/utils';

const Index = () => {
  const [show, setShow] = useState(false);
  const { initialState } = useModel('@@initialState');
  useEffect(() => {
    const path = history.location.pathname;
    // 更具path找到对应的父级
    const parent = findParentByKey(PERMISSIONS, path.slice(1, path.length));
    const children = parent?.children || [];
    // 服务端返回的权限
    const permissions = initialState?.roleInfo?.permissions || []
    // 找到最近一个有权限的
    const item = children.find((item: any) => permissions.includes(item.value));
    if(item) {
      const newPath  = `/${item.value}`
      if(path === newPath) return
      history.replace(newPath)
    }
    else {
      setShow(true)
    }
    // const permissions = initialState?.roleInfo?.permissions;
    // const path = getInitPath(permissions || []);
    console.log('path', path);
  }, []);
  return !show ? (
    <div></div>
  ) : (
    <Result
      status="warning"
      title="您暂时没有当前权限，请联系管理员"
      extra={
        <Button
          type="primary"
          key="console"
          onClick={() => {
            history.replace('/');
          }}
        >
          返回首页
        </Button>
      }
    />
  );
};

export default Index;
